import React,{useState} from 'react'
import Select from 'react-select';
import fontFamilies from '.././../data/font.json'

const FontFamilyPicker = ({fFamily, handleFontFamily}) => {
   
    const [font, setFont] = useState('');
    const selectStyles = {
        control: () => ({
            display: `flex`,
            fontFamily: `${font} !important`,
            alignItems: 'center',
            border: `1px solid hsl(0, 0%, 80%)`,
            fontSize: `14px`,
            borderRadius:`5px`
        }),
    };
    const MyOption = props => {
        const { innerProps, innerRef } = props;
        return (
            <article ref={innerRef} {...innerProps} className="custom-option">
                <div className="ct-option-items" style={{ fontFamily: props.data.value }}>{props.data.label} </div>
            </article>
        );
    };
    const handleChange = e => {
        handleFontFamily(e.value, e.font_weight)
        setFont(e.value);
    }

    const fontIndex = fontFamilies.findIndex(el=>el.value === fFamily);
  return (
    <Select
    styles={selectStyles}
    onChange={handleChange}
    components={{ Option: MyOption }}
    options={fontFamilies}
    defaultValue={fontFamilies[fontIndex]}
/>
  )
}

export default FontFamilyPicker